import { ACCESS_EMBEDDED_URL } from "constants/urls"
import { usePageAssets } from "hooks/usePageAssets"
import Button from "components/ui/Button"
import Container from "components/ui/Container"
import Heading from "components/ui/Heading"
import SplitContainer from "components/ui/Layout/SplitContainer"

function HeroSection() {
  const { getAsset } = usePageAssets()
  const illustration = getAsset("internal-tooling-hero-background")
  return (
    <Container section>
      <SplitContainer
        className="mt-10 lg:mt-0 lg:py-10 xl:py-20"
        image={illustration}
        imageSize="large"
        imageClassName="scale-150 md:scale-110 lg:scale-110 xl:scale-100 lg:translate-x-[20%] xl:translate-x-[15%] 2xl:translate-x-[20%] mt-[10%] md:mt-0 lg:mt-[5%]"
      >
        <Heading
          level="h1"
          title="Enable analytics directly in your team's internal tools"
          subtitle={
            <>
              Integrate the same Preset charts and dashboards in your home-grown
              apps without the learning curve, and let your team explore their
              data without taking them out of their workflows.
            </>
          }
          size="huge"
          narrow
        />
        <Button
          className="mt-7"
          color="green"
          size="medium"
          href={ACCESS_EMBEDDED_URL}
          trackClick="Request Access (hero)_Use Cases - Internal Tooling"
          shadow
        >
          Request Access
        </Button>
      </SplitContainer>
    </Container>
  )
}

export default HeroSection
